<template>
  <div
    class="nav"
    :class="[deviceType(), activityEnd ? 'activityEnd' : '']"
  >
    <ul v-if="deviceType() == 'pc'">
      <li
        @click="showNav(false)"
        v-if="activityEnd"
      >
        <a
          :href="store.state.articlesData.doubleStore"
          target="_blank"
          class="market_download_above"
        >{{$t('home.nav.Down')}}</a>
      </li>
      <li v-if="!activityEnd">
        <router-link
          to="/pre"
          target="_blank"
          class="market_phone_above"
        >{{$t('home.nav.ReserveGift')}}</router-link>
      </li>
      <li>
        <a
          href="#"
          @click.prevent="scrollToSpecificHeight(900)"
        >{{$t('home.nav.CharacterIntroduction')}}</a>
      </li>
      <li>
        <a
          href="#"
          @click.prevent="scrollToSpecificHeight(1800)"
        >{{$t('home.nav.Gameplay')}}</a>
      </li>
      <li>
        <a
          :href="store.state.articlesData.payUrl"
          target="_blank"
          class="market_pay_above"
        >
          {{$t('home.nav.AttentionFB')}}
        </a>
      </li>
    </ul>
    <div
      class="gameInfo"
      v-else
    >
      <img src="../../../assets/images/icon.png">
      <div class="iconText"></div>
      <!-- <p>
        ZERO TO HERO
        <i>Pixel saga</i>
      </p> -->
    </div>
    <!-- 语言选择 -->
    <LanguageSwitch
      :type="projectType().name"
      :sort="deviceType() + 'gw'"
    />
    <!-- 分享 -->
    <div class="share">
      <a
        :href="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
        target="_blank"
      >
        <img
          class="'market_FBdraw_above'"
          src="../../../assets/images/fb2.png"
        />
      </a>
      <a
        :href="store.state.articlesData.discordShare"
        target="_blank"
      >
        <img
          :class="'market_DC_jump'"
          src="../../../assets/images/dc2.png"
        >
      </a>
      <a
        @click="fillUpShare(ShareData)"
        v-if="deviceType() == 'pc'"
        target="_blank"
      >
        <img
          :class="'market_FB_jump'"
          src="../../../assets/images/line2.png"
        >
      </a>
      <gw-nav
        :ShareData="ShareData"
        v-if="deviceType() == 'wap'"
        :position="'gwwap'"
        :activityEnd="activityEnd"
      ></gw-nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { projectType } from "@/util/global";
import { shareFB } from "@/util/share";
import { deviceType, scrollToSpecificHeight } from "@/util/base";
import gwNav from "./gwnav.vue";
import { useStore } from "vuex";
const store = useStore();

defineProps(["ShareData", "activityEnd"]);

import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const XhLang = locale.value;

const fillUpShare = (data) => {
  const shareLink = window.location.href;
  let shareTitle = "";
  let shareImg = "";
  for (const item of data) {
    if (item.label === "shareTitle") {
      shareTitle = item.content;
    }
    if (item.label === "shareImg") {
      shareImg = item.content;
    }
  }
  shareFB(shareLink, shareTitle, shareImg);
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  z-index: 1002;
  top: 0;
  background: rgba(64, 4, 137, 0.85);
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  color: #fff;
  display: flex;
  .gameInfo {
    display: flex;
    align-self: center;
    align-items: center;
    margin: 0 0.2rem;
    img {
      height: 0.5rem;
    }
    .iconText {
      width: 1.85rem;
      height: 0.43rem;
      margin-left: 0.15rem;
      background: url("../../../assets/images/icon-text.png") no-repeat center;
      background-size: 100% auto;
    }
    p {
      display: flex;
      flex-direction: column;
      line-height: 0.25rem;
      font-size: 0.22rem;
      margin-left: 0.15rem;
      i {
        font-size: 0.2rem;
      }
    }
  }
  ul {
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    li {
      min-width: 3rem;
      float: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      font-size: 0.26rem;
      &::after,
      &::before {
        width: 0.14rem;
        height: 0.16rem;
        margin: 0 0.1rem;
        content: ""; /* 必须有content属性 */
        display: block; /* 伪元素默认是行内元素，需要设置为块级元素才能设置宽高 */
      }
      &:hover,
      &.active {
        color: #fff228;
        &::after {
          background: url("../../../assets/images/nav-left.png") no-repeat
            center;
          background-size: 100% auto;
        }
        &::before {
          background: url("../../../assets/images/nav-right.png") no-repeat
            center;
          background-size: 100% auto;
        }
      }
      a {
        color: #fff;
      }
    }
  }
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.2rem;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.4rem;
        margin: 0 0.08rem;
      }
    }
  }
}
.wap {
  height: 0.9rem;
  justify-content: space-between;
  .share {
    margin-right: 0.9rem;
    a {
      img {
        width: 0.55rem;
      }
    }
  }
}
</style>
